import axios from 'axios';
import { API } from '../utils/static-data';
import { getHttpErrorCodeMessage, getAuthHeader } from '../utils/utils';

class ConfigService {

  static async getSectors(parish) {
    const result = await axios.get(`${API}/config/sector/byParish/${parish}`, {
      headers: {
        ...getAuthHeader()
      }
    });
    if (result.status !== 200) {
      throw new Error(getHttpErrorCodeMessage(result.status));
    }
    return result.data;
  }

  static async getParentOrganisms() {
    try {
      const result = await axios.get(`${API}/organism/ejecutivas/all`, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        }
      });
      return result.data;
    } catch (error) {
      console.dir(error);
      throw new Error(getHttpErrorCodeMessage(404));
    }
  }

  static async getUsers() {
    try {
      const result = await axios.get(`${API}/user`, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        }
      });
      return result.data;
    } catch (error) {
      console.dir(error);
      throw new Error(getHttpErrorCodeMessage(404));
    }
  }

  static async getMeasurement() {
    try {
      const result = await axios.get(`${API}/config/measurement`, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        }
      });
      return result.data;
    } catch (error) {
      console.dir(error);
      throw new Error(getHttpErrorCodeMessage(404));
    }
  }

}

export class OrganismService {

  static async createOrganism(organism) {
    try {
      const result = await axios.post(`${API}/organism`, organism, {
        headers: {
          ...getAuthHeader(),
          'Content-Type' : 'application/json'
        }
      });
      return result.data;
    } catch (error) {
      throw new Error(error);
    }
  }

  static async savePlace(newPlace) {
    try {
      const place = await axios.post(`${API}/places`, newPlace, {
        headers: {
          ...getAuthHeader()
        }
      });
      return place.data;
    } catch (error) {
      throw new Error(error);
    }
  }

  static async getPlacesByOrganism(organism) {
    try {
      const places = await axios.get(`${API}/places/${organism}`, {
        headers: {
          ...getAuthHeader()
        }
      });
      return places.data;
    } catch (error) {
      throw new Error(error);
    }
  }

}

export default ConfigService;